<template>
    <div>
        <!-- 这里是发帖 -->
        <div class="con1">
            <el-button v-if="this.$store.state.me.is_login" style="font-size:40px" type="text" @click="FaTie">

                <div class="fatieya">
                    <div class="row">
                        <div class="clo-xs-2 col-sm-1">
                            <!-- <a href="#" target="_blank"> -->
                                <img width="45px" height="45px" style="border-radius: 50%;" :src="this.$store.state.me.photo" :alt="`${this.$store.state.me.name}的头像`">
                            <!-- </a> -->
                        </div>
                        <div class="clo-xs-10 col-sm-11">
                            <div class="color123">
                                {{ this.$store.state.me.name }},有什么新鲜事想告诉大家
                            </div>
                        </div>
                    </div>
                </div>

            </el-button>

            <el-dialog
                title="创建帖子"
                :visible.sync="dialogVisible"
                width="80%"
                :before-close="handleClose">

            <!-- 输入框 -->
            <div class="home">
                <mavon-editor :boxShadow="false" :codeStyle="codeStyle" :toolbars="toolbars" :tabSize="tabSize" v-model="content" 
                :ishljs="true" ref="md" @change="change" style="margin-left: 18px;  
                min-height:450px; max-height: 450px;"/>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="createMessage">确 定</el-button>
            </span>
            </el-dialog>
        </div>

        <!-- 自己直接发帖会出现动画 -->
        
        <!-- 刷新之后textarea1会清空 就不会出现动画 也就是说直接实现了发帖子才有动画 刷新之后不会出现所有帖子都动画出现的抽象画面 -->
        <div id="TIEZI" class="tiezi" v-for="item in list2" :key="item.id" @mouseover="flag = item.id" @mouseleave="flag = 0">
            <div class="head">
                <img width="45px" height="45px" style="border-radius: 50%;" :src="item.photo">
                <div>
                    <div style="font-size:16px ;margin-left: 10px">{{ item.userName }}</div>
                    <div style="font-size:16px ;margin-left: 10px">{{ item.createTime }}</div>
                </div>
                <div style="width: 660px;">
                    
                    <el-popconfirm
                    @confirm="deleteMessage(item.id)"
                    confirm-button-text='好的'
                    cancel-button-text='不用了'
                    icon="el-icon-info"
                    icon-color="red"
                    title="确定删除这个帖子吗？"
                    >
                    
                    <span slot="reference" v-show="item.id == flag && item.userId == $store.state.me.id" style="float: right; 
                    cursor: pointer; color: white; font-size: 14px; padding-left: 10px; 
                    padding-right: 10px; padding-top: 3px; padding-bottom: 3px; background-color: #F56C6C; border-radius: 7px;">
                        删除
                    </span>
                    </el-popconfirm>
                </div>
            </div>
            <div class="ueditor">
                <el-popover
                    placement="bottom"
                    title="标题"
                    width="200"
                    trigger="manual"
                    content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    v-model="visible">
                    <mavon-editor slot="reference" class="markdown-body" :boxShadow="false" style="margin-left: 55px; min-width: 827px; max-width: 827px; 
                    min-height: 10px;" codeStyle="monokai" v-html="item.content"></mavon-editor>
                </el-popover>
            </div>
            <hr>
            <Reply v-if="isShow" :item="item"></Reply>
        </div>
    </div>
</template>

<script>
    import Reply from '../components/Reply.vue'
    import Url from "@/constant/Url";
    import $ from "jquery"
    import 'animate.css'
    import { nanoid } from 'nanoid';

    export default {
        name:'Fatie',
        components: {
            Reply,
        },
        data() {
            return {
                flag: 0,
                isShow: false,
                visible: false,

                content: "",
                tabSize:4,
                page_article:undefined,
                html_content:undefined,
                md_content:undefined,
                toolbars: {
                    bold: true, // 粗体
                    italic: true, // 斜体
                    header: true, // 标题
                    underline: true, // 下划线
                    strikethrough: true, // 中划线
                    mark: true, // 标记
                    superscript: true, // 上角标
                    subscript: true, // 下角标
                    quote: true, // 引用
                    ol: true, // 有序列表
                    ul: true, // 无序列表
                    link: true, // 链接
                    imagelink: true, // 图片链接
                    code: true, // code
                    table: true, // 表格
                    fullscreen: true, // 全屏编辑
                    readmodel: true, // 沉浸式阅读
                    htmlcode: true, // 展示html源码
                    help: true, // 帮助
                    undo: true, // 上一步
                    redo: true, // 下一步
                    trash: true, // 清空
                    save: true, // 保存（触发events中的save事件）
                    navigation: true, // 导航目录
                    alignleft: true, // 左对齐
                    aligncenter: true, // 居中
                    alignright: true, // 右对齐
                    subfield: true, // 单双栏模式
                    preview: true // 预览
                },
                codeStyle:'monokai-sublime',//主题
                test_html:undefined,

                dialogVisible: false,
                list1:[],
                list2:[],
            };
        },
        methods: {
            change(value, render){
                this.test_html = render;
            },
            FaTie() {
                //首先要保证自己是登录了的
                if(this.$store.state.me.is_login) 
                    this.dialogVisible = true
                else {
                    this.$notify({
                    message: '请先登录',
                    type: 'info', //表示这个是消息提醒
                    offset: 100,
                    duration: 2000,
                    });
                }       
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => {});
            },
            createMessage() {
                if(!this.content.trim()) {
                    this.$message.error('输入不能为空');
                    return 
                }

                const t = new Date();
                this.dialogVisible = false
                let times = t.toLocaleDateString().split('/')
                let time = times[0] + "-" + times[1] + "-" + times[2]

                this.list1.unshift({
                    id: nanoid(), 
                    userId: this.$store.state.me.id, // 用户id
                    userName: this.$store.state.me.name, // 用户名称
                    content: this.test_html, // html内容
                    markdown: this.content, // markdown内容
                    createTime: time + " " +  t.toLocaleTimeString(), // 创建时间
                    photo: this.$store.state.me.photo // 头像
                })
                
                const vue = this
                const store = this.$store
                // /* 在这里发给服务器数据 8毛/小时 能不开就不开*/
                // const data = {
                //     userId: store.state.me.id,
                //         userName: store.state.me.name,
                //         content: vue.test_html,
                //         markdown: vue.content,
                //         photo: store.state.me.photo,
                // }
                $.ajax({
                    url: Url.cPostMessageUrl,
                    type: "post",
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        userId: store.state.me.id,
                        userName: store.state.me.name,
                        content: vue.test_html,
                        markdown: vue.content,
                        photo: store.state.me.photo,
                    },
                    success(resp) {
                        if (resp.error_message === 'success') {
                            vue.readMessage()
                            vue.content = ""
                        }
                    }
                })
            },
            readMessage() {
                const vue = this
                const store = this.$store

                $.ajax({
                    url: Url.rPostMessageUrl,
                    type: "post",
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    success(resp) {
                        if (resp.error_message === 'success') {
                            vue.list2 = JSON.parse(resp.list)
                            vue.isShow = true
                        }
                    }
                })
            },
            deleteMessage(id) {
                const vue = this
                const store = this.$store

                $.ajax({
                    url: Url.dPostMessageUrl,
                    type: "post",
                    data: {
                        id: id,
                    },
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    success(resp) {
                        if (resp.error_message === 'success') {
                            vue.readMessage()
                        }
                    }
                })
            }
        },
        mounted() {
            this.readMessage()
        },
    }
</script>

<style scoped>
.con1 {
    display: flex;
    justify-content: center;
}
/* 关于发帖的样式 */
.color123 {
    margin-top:4px;
    background-color: #E4E6E9;
    width: 790px;
    font-size: 30px;
    line-height: 40px;
    float: left
}

.fatieya {
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    width: 900px;
    height: 80px;
    background: #FFFFFF;
    padding: 10px;
    border-radius: 10px;
}
.head {
    display: flex;
}


.body{
    font-size:18px;
    margin-left: 50px;
    background-color: #E4E6E9;;
    height: auto;
    overflow: hidden;
    white-space: pre-wrap;
    height: fit-content; /* 保证高度随着字数的增多而换行 */
}
.comment{
    font-size:18px;
    display: flex;
    padding: 2px;
}
.comment1{
    cursor: pointer;
    justify-content: center;
    width: 33%;
    /* margin-left: 30px; */
    font-size:18px;
    display: flex;
}
.comment2{
    cursor: pointer;
    justify-content: right;
    margin-right: 100px;
    width: 66%;
    /* margin-left: 300px; */
    font-size:18px;
    display: flex;
}
.comment3{
    justify-content: center;
    width: 33%;
    /* margin-left: 300px; */
    font-size:18px;
    display: flex;
}
.ma {
    position: relative;
    display: flex;
    width: 100%;

    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* filter: blur(3px); */
}
.tiezi {
    opacity: 0.85;
    position: relative;
    border-radius: 10px;
    padding: 10px;
    font-size:30px;
    margin-top:20px;
    width: 900px;
    height: auto;
    background-color:#FFFFFF;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    
    word-break: break-all;
    overflow: hidden;
}
</style>